import { render, staticRenderFns } from "./newProduct.vue?vue&type=template&id=7cc0ff92&scoped=true&"
import script from "./newProduct.vue?vue&type=script&lang=js&"
export * from "./newProduct.vue?vue&type=script&lang=js&"
import style0 from "./newProduct.vue?vue&type=style&index=0&id=7cc0ff92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0ff92",
  null
  
)

export default component.exports